(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bd-announcement-strip')) {
  customElements.define('bd-announcement-strip', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => { if (this.isConnected) this.initialize(); }, { once: true });
      } else this.initialize();
    }
    initialize() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.button = this.querySelector('[data-ticker-pause]');
      this.window = this.querySelector('[data-ticker-window]');
      this.group = this.querySelector('[data-ticker-group]');
      if (!this.button || !this.group) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.syncMotion = () => { this.toggleAttribute('data-reduced-motion', this.motion.matches); this.button.hidden = this.motion.matches; this.syncPause(); };
      this.motion.addEventListener('change', this.syncMotion, options);
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.syncPause(); }, options);
      this.window.addEventListener('focusin', event => { this.setAttribute('data-keyboard', ''); event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }, options);
      this.window.addEventListener('focusout', event => { if (!this.window.contains(event.relatedTarget)) { this.window.scrollLeft = 0; this.removeAttribute('data-keyboard'); } }, options);
      document.addEventListener('visibilitychange', () => this.syncPause(), options);
      document.addEventListener('shopify:block:select', event => { if (this.contains(event.target)) { this.paused = true; this.syncPause(); } }, options);
      this.observer = new ResizeObserver(() => {
        const duration = this.group.scrollWidth / (Number(this.dataset.speed) || 30);
        this.style.setProperty('--bd-ticker-duration', `${Math.max(20, duration)}s`);
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.getBoundingClientRect().height}px`);
      });
      this.observer.observe(this);
      this.observer.observe(this.group);
      document.documentElement.style.removeProperty('--announcement-bar-button-width');
      this.setAttribute('data-ready', '');
      this.syncMotion();
    }
    syncPause() {
      this.toggleAttribute('data-paused', this.paused || document.hidden);
      this.button.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      this.button.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  const initFooter = () => {
    document.querySelectorAll('.bd-footer').forEach(footer => {
      if (footer.dataset.groupsReady) return;
      footer.dataset.groupsReady = 'true';
      const query = window.matchMedia('(min-width:741px)');
      const groups = [...footer.querySelectorAll('.bd-footer-group')];
      const sync = () => groups.forEach(group => {group.open = query.matches;});
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {if (query.matches) event.preventDefault();}));
      query.addEventListener('change', sync);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initFooter); else initFooter();
  document.addEventListener('shopify:section:load',initFooter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rever-nursery-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rb-nursery-builder')) {
  customElements.define('rb-nursery-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.groups = ["bassinet", "cot", "chair", "chest", "carseat", "pram", "mat", "mattress"];
      this.picks = new Map(); this.reviewing = false; this.step = 0; this.busy = false; this.added = false;
      this.dialog = this.querySelector('dialog');
      this.s = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.cards.forEach(card => {
        card.product = JSON.parse(card.querySelector('[data-product]').textContent);
        card.querySelector('[data-choose]').addEventListener('click', () => this.pick(card));
        card.querySelector('[data-variant]').addEventListener('change', () => this.variantChanged(card));
      });
      this.querySelector('[data-open]').addEventListener('click', () => { this.dialog.showModal(); document.documentElement.classList.add('rb-nursery-lock'); this.showStep(this.step); });
      this.querySelector('[data-close]').addEventListener('click', () => { if (!this.busy) this.dialog.close(); });
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('rb-nursery-lock'));
      this.querySelector('[data-mobile-review]').addEventListener('click', () => this.reviewing ? this.showStep(this.step) : this.review());
      this.querySelector('[data-edit]').addEventListener('click', () => this.showStep(this.step));
      this.querySelector('[data-mobile-next]').addEventListener('click', () => { if(this.reviewing) this.addToCart(); else if(this.step < this.groups.length - 1) this.showStep(this.step + 1); else this.review(); });
      this.querySelector('[data-mobile-skip]').addEventListener('click', () => this.querySelector('[data-skip]').click());
      this.dialog.addEventListener('cancel', event => { if (this.busy) event.preventDefault(); });
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.showStep(Number(button.dataset.step))));
      this.querySelector('[data-next]').addEventListener('click', () => this.step < this.groups.length - 1 ? this.showStep(this.step + 1) : this.review());
      this.querySelector('[data-back]').addEventListener('click', () => this.showStep(Math.max(0,this.step - 1)));
      this.querySelector('[data-skip]').addEventListener('click', () => { if (this.busy || this.added) return; this.picks.delete(this.groups[this.step]); this.render(); this.step < this.groups.length - 1 ? this.showStep(this.step + 1) : this.review(); });
      this.querySelector('[data-add]').addEventListener('click', () => this.addToCart());
      this.render();
    }
    disconnectedCallback() { if(this.dialog?.open) { this.dialog.close(); document.documentElement.classList.remove('rb-nursery-lock'); } }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency:this.dataset.currency}).format(cents / 100); }
    getVariant(card) { return card.product.variants.find(v => String(v.id) === card.querySelector('select').value); }
    pick(card) { if (this.busy || this.added) return; const variant = this.getVariant(card); if (!variant?.available) return; this.picks.set(card.dataset.category,{card,product:card.product,variant}); this.render(); }
    variantChanged(card) {
      const variant = this.getVariant(card); if (!variant) return;
      card.querySelector('[data-price]').textContent = this.money(variant.price);
      const img = card.querySelector('img'); if (img) { img.removeAttribute('srcset'); img.src = variant.image || card.product.image; }
      if (this.picks.get(card.dataset.category)?.card === card) { if (variant.available) this.picks.set(card.dataset.category,{card,product:card.product,variant}); else this.picks.delete(card.dataset.category); }
      this.render();
    }
    showStep(index) {
      if (this.busy) return; this.step = index; this.reviewing = false; this.dialog.classList.remove('is-review');
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = Number(panel.dataset.panel) !== index; });
      this.querySelectorAll('[data-step]').forEach(button => { if(Number(button.dataset.step) === index) button.setAttribute('aria-current','step'); else button.removeAttribute('aria-current'); });
      this.querySelector('[data-back]').disabled = index === 0;
      this.querySelector('[data-next]').textContent = index === this.groups.length - 1 ? this.s.review : this.s.next;
      const current=this.querySelector(`[data-step="${index}"]`), tabs=this.querySelector('.rb-nursery__steps');
      tabs.scrollLeft=current.offsetLeft-tabs.offsetLeft-(tabs.clientWidth-current.offsetWidth)/2;
      this.updateMobileActions();
      this.querySelector('.rb-nursery__workspace').scrollTop = 0;
      if(this.dialog.open) this.querySelector(`[data-panel="${index}"] h3`).focus({preventScroll:true});
    }
    review() {
      this.reviewing=true; this.dialog.classList.add('is-review'); this.updateMobileActions();
      const summary=this.querySelector('.rb-nursery__summary');
      summary.scrollIntoView({block:'start',behavior:'auto'}); summary.focus({preventScroll:true});
    }
    updateMobileActions() {
      const button=this.querySelector('[data-mobile-next]');
      const next=this.querySelector(`[data-step="${Math.min(this.step+1,this.groups.length-1)}"] .rb-nursery__step-label`).textContent;
      button.textContent=this.reviewing?(this.busy?this.s.adding:this.added?this.s.cart_retry:this.s.add):this.step===this.groups.length-1?this.s.review:this.s.next_category.replace('[category]',next);
      button.disabled=this.busy||(this.reviewing&&!this.picks.size);
      this.querySelector('[data-mobile-skip]').hidden=this.reviewing;
      const review=this.querySelector('[data-mobile-review]');
      review.firstChild.textContent=this.reviewing?this.s.edit_bundle+' ':this.s.review+' ';
      this.querySelector('[data-mobile-count]').textContent=this.reviewing?'':'('+this.picks.size+')';
    }
    render() {
      const agraSelected=String(this.picks.get('cot')?.product.id)==='9807566536951';
      if(agraSelected) this.picks.delete('mattress');
      this.cards.filter(card=>card.dataset.category==='mattress').forEach(card=>card.hidden=agraSelected);
      this.querySelector('[data-mattress-note]').textContent=agraSelected?this.s.mattress_included:this.s.mattress_note;
      const values = this.groups.map(g=>this.picks.get(g)).filter(Boolean);
      const subtotal = values.reduce((sum,p)=>sum+p.variant.price,0);
      this.qualifies = values.length >= 2 && subtotal >= 200000;
      const saving = this.qualifies ? values.reduce((sum,p)=>sum+Math.round(p.variant.price*.1),0) : 0;
      this.querySelector('[data-count]').textContent = this.s.count.replace('[count]',values.length);
      const list = this.querySelector('[data-selection]'); list.replaceChildren();
      if(!values.length) { const empty=document.createElement('p'); empty.className='rb-nursery__empty'; empty.textContent=this.s.empty; list.append(empty); }
      values.forEach(p=>{
        const row=document.createElement('div'); row.className='rb-nursery__selected-row';
        const img=document.createElement('img'); img.src=p.variant.image||p.product.image; img.alt=p.product.title;
        const copy=document.createElement('div'), title=document.createElement('strong'), option=document.createElement('small'), price=document.createElement('strong');
        title.textContent=p.product.title; option.textContent=p.variant.title==='Default Title'?'':p.variant.title; price.textContent=this.money(p.variant.price); copy.append(title,option,price);
        const remove=document.createElement('button'); remove.type='button'; remove.textContent='×'; remove.setAttribute('aria-label',this.s.remove+' '+p.product.title); remove.disabled=this.busy||this.added; remove.addEventListener('click',()=>{this.picks.delete(p.product.category);this.render();});row.append(img,copy,remove);list.append(row);
      });
      this.cards.forEach(card=>{const selected=this.picks.get(card.dataset.category)?.card===card;card.classList.toggle('is-selected',selected);const button=card.querySelector('[data-choose]'),v=this.getVariant(card);button.textContent=!v?.available?this.s.unavailable:selected?this.s.selected:this.s.select;button.setAttribute('aria-pressed',String(selected));button.disabled=this.busy||this.added||!v?.available;card.querySelector('select').disabled=this.busy||this.added;});
      this.querySelectorAll('[data-step]').forEach(b=>b.classList.toggle('is-complete',this.picks.has(this.groups[Number(b.dataset.step)])));
      this.querySelector('[data-subtotal]').textContent=this.money(subtotal);this.querySelector('[data-saving]').textContent='−'+this.money(saving);this.querySelector('[data-total]').textContent=this.money(subtotal-saving);this.querySelector('[data-mobile-total]').textContent=this.money(subtotal-saving);this.querySelector('[data-mobile-review]').disabled=this.busy;
      this.querySelectorAll('[role=progressbar]').forEach(progress=>{progress.setAttribute('aria-valuenow',Math.min(2000,subtotal/100));progress.querySelector('span').style.width=Math.min(100,subtotal/2000)+'%';});
      this.querySelector('[data-deal-status]').textContent=this.qualifies?this.s.unlocked_short:subtotal===0?this.s.offer_short:subtotal<200000?this.s.remaining_short.replace('[amount]',this.money(200000-subtotal)):this.s.need_two;
      this.querySelector('[data-deal]').classList.toggle('is-unlocked',this.qualifies);
      this.querySelector('[data-mobile-saving]').textContent=this.qualifies?this.s.saving_short.replace('[amount]',this.money(saving)):'';
      this.updateMobileActions();
      this.querySelector('[data-eligibility]').textContent=this.qualifies?this.s.unlocked:subtotal<200000?this.s.remaining.replace('[amount]',this.money(200000-subtotal)):this.s.need_two;
      const add=this.querySelector('[data-add]');add.disabled=!values.length||this.busy;add.textContent=this.busy?this.s.adding:this.added?this.s.cart_retry:this.s.add;
    }
    async addToCart() {
      if(this.busy || !this.picks.size) return;
      if(this.added) { this.openCart(); return; }
      this.busy=true; this.querySelector('[data-error]').textContent='';this.render();
      try {
        let changed=false;
        for(const pick of this.picks.values()) {
          const response=await fetch(this.dataset.root+'products/'+encodeURIComponent(pick.product.handle)+'.js',{credentials:'same-origin'});
          if(!response.ok) throw new Error(this.s.error);
          const fresh=await response.json(),v=fresh.variants.find(v=>v.id===pick.variant.id);
          if(!v?.available) { pick.variant.available=false;changed=true; }
          else if(v.price!==pick.variant.price) { pick.variant.price=v.price;changed=true; }
        }
        if(changed) { this.busy=false;this.render();throw new Error(this.s.changed); }
        const items=[...this.picks.values()].map(p=>({id:p.variant.id,quantity:1}));
        this.requestSent=true;
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        if(!response.ok) { this.requestSent=false; const error=await response.json();throw new Error(error.description||this.s.error); }
        this.added=true;this.busy=false;this.render();this.openCart();
      } catch(error) { if(this.requestSent) this.added=true; this.busy=false;this.render();this.querySelector('[data-error]').textContent=this.requestSent?this.s.cart_retry+': '+this.s.error:error.message||this.s.error; }
    }
    openCart() {
      const cart=this.dataset.root+'cart';
      window.location.assign(this.qualifies&&this.dataset.code?this.dataset.root+'discount/'+encodeURIComponent(this.dataset.code)+'?redirect='+encodeURIComponent(cart):cart);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
